import React, { useState } from "react";

const CommentComponent = ({ comment, truncateLength }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    if (comment.length <= truncateLength) return;
    setExpanded(!expanded);
  };

  const commentToRender = (comment, truncateLength) => {
    const commentStr = typeof comment === "number" ? String(comment) : comment;

    if (typeof commentStr !== "string") {
      return "";
    }

    if (commentStr.length <= truncateLength || expanded) {
      return commentStr;
    }
    return `${commentStr.slice(0, truncateLength)}...`;
  };

  const styles = {
    cursor: comment.length > truncateLength ? "pointer " : "auto ",
  };

  return (
    <p
      className="p4 description mobile-hidden"
      style={styles}
      onClick={toggleExpanded}
    >
      {commentToRender(comment, truncateLength)}
    </p>
  );
};
export default CommentComponent;
